export default {
  common: (locale) => {
    switch (locale) {
      case 'sr-Latn':
        return import(/* webpackChunkName: "i18n.sr-Latn" */'./sr-Latn');
      default:
        return import(/* webpackChunkName: "i18n.en" */'./en');
    }
  },
};
